import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CompanyLocationModel } from 'common/models/page-models/internship-company/company-location/company-location-data.model';
import { CompanyLocationMetaModel } from 'common/models/page-models/internship-company/company-location/company-location-form-meta.model';
import { CompanyLocationListingModel } from 'common/models/page-models/internship-company/company-location/company-location-grid.model';
import { WidgetModel } from 'common/models/utility-models/base-model';
import { GridWidgetModel } from 'common/models/utility-models/list-utility.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { CompanyLocationGridWidgetService } from 'common/widget/internship-company/internship-location-grid-widget.service';


@Injectable({
    providedIn: 'root'
})
export class CompanyLocationGridResolver extends GridResolver<CompanyLocationModel, CompanyLocationListingModel> {
    constructor(
        protected fs: CompanyLocationGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override initWidget(envelopeType: any, transferData: any): WidgetModel {
        const widget = new GridWidgetModel();
        const metaModel = this.pageService.getMetaModel();
        widget.recordPerPage = metaModel.properties?.recordPerPage;
        widget.searchableFeilds = metaModel.properties?.searchableFields;
        transferData.formData = new CompanyLocationModel();
        transferData.formMeta = new CompanyLocationMetaModel().getMetaModel();
        // this.fs.getFilterOptions(transferData.filterMeta);
        widget.transferData = transferData;
        return widget;
    }
}
